import { render, staticRenderFns } from "./StoryAbstract.vue?vue&type=template&id=cf9f2c82&scoped=true&"
import script from "./StoryAbstract.vue?vue&type=script&lang=js&"
export * from "./StoryAbstract.vue?vue&type=script&lang=js&"
import style0 from "./StoryAbstract.vue?vue&type=style&index=0&id=cf9f2c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f2c82",
  null
  
)

export default component.exports